import React from 'react';
import PropTypes from 'prop-types';
import { isPWAInstalled } from '../features/search/util';
import { useSelector } from 'react-redux';
import CogMenu from './CogMenu';

const LoginButton = (props) => {
  const ip = useSelector(state => state.counter.ip);

  return (
      <div className='row'>
        <div className='col-12'>
          {/* <a id="subscribeBtn" rel="noreferrer" href="https://www.tg.org.au/etgcomplete" target="_blank" className="btn btn-info" style={{ width: '16rem', marginRight: '1rem' }} >Subscribe</a> */}
          {/* <a id="logInbtn" onClick={props.handleLoginClick} href="#" title="Log in" data-target="#tglogin" className="btn btn-info" style={{ width: '16rem' }} >Log in</a> */}
          <CogMenu/>
        </div>
        {isPWAInstalled() &&
          <div className='col-12' style={{ marginTop: '1rem', marginBottom: '2rem' }}>
            <a id="openApp" href="#" onClick={props.handleAccessToken} className="btn btn-info btn-block">Access key</a>
          </div>} 
      </div>
  )
};

export default LoginButton;

LoginButton.propTypes = {
  handleLoginClick: PropTypes.func.isRequired,
  handleDXPLoginClick: PropTypes.func.isRequired,
  handleAccessToken: PropTypes.func.isRequired
};